import { render, staticRenderFns } from "./side-bar-store.vue?vue&type=template&id=0e9b1d7e"
import script from "./side-bar-store.vue?vue&type=script&lang=js"
export * from "./side-bar-store.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports